export const UPFLOW_MODAL_STORE_NAME = 'upflow-modal-store';
